import { Star } from "lucide-react";
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";

const testimonials = [
  {
    quote:
      "We've had the pleasure of working with Robust Entertainment, and they've consistently delivered a professional, reliable service while always being a pleasure to work with. Their team is well organised, punctual, and always goes the extra mile. Communication is excellent from booking through to the event itself, making the whole process straightforward and stress-free. We'd be happy to recommend Robust Entertainment to anyone looking for quality entertainment services.",
    author: "Jack, Entertainment Manager — Lady's Mile Holiday Park",
    avatar: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/8bbqa4pc_Jack.jpeg",
  },
  {
    quote:
      "I'll always be grateful to Robust Entertainment for believing in me and helping me take the next step in my career. Their guidance, support, and industry knowledge played a huge part in me securing my role as Entertainment Manager at Cofton Holidays. Throughout the process, they were professional, encouraging, and genuinely invested in helping me succeed. I can't thank the team enough for opening the door to such an amazing opportunity, and I'd highly recommend Robust Entertainment to anyone looking to grow their career in the entertainment industry.",
    author: "Lilly, Entertainment Manager — Cofton Holidays",
    avatar: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/02icb7nr_Lilly.jpeg",
  },
  {
    quote:
      "I have had the pleasure of working with Robust Entertainment through my show, Elvis – One More Time, and the venues and events they provide are consistently of a high standard, with clear communication throughout the booking process. All event details are supplied promptly, arrangements are well organised, and payments are always made on time. Robust Entertainment genuinely values both its clients and performers, and I would be very happy to recommend them to venues, event organisers and fellow entertainers.",
    author: "Gary Jay — Elvis: One More Time",
    avatar: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/z523skgh_Elvis%20Headshot%204.png",
  },
  {
    quote:
      "I've had the pleasure of working with Robust Entertainment and their Managing Director, Paul, for over 20 years, and in all that time their dedication, creativity, and professionalism have never wavered. Paul leads with passion and integrity, and it shows in every production they deliver for Park Holidays UK. The team consistently goes above and beyond, creating shows that are polished, engaging, and full of energy. What truly sets them apart is the care they put into every detail and the genuine pride they take in their work. After two decades of collaboration, I can say with confidence that Robust Entertainment is a company you can trust, not just for exceptional entertainment, but for a partnership built on reliability, respect, and shared success.",
    author: "John Flack — Head of Entertainment, Park Holidays UK",
    avatar: "https://customer-assets-lqy194kg.emergentagent.net/job_entertainment-hub-187/artifacts/4a61xhc0_images.jpg",
    isLogo: true,
  },
];

export const Testimonials = () => {
  return (
    <section id="testimonials" className="relative py-14 lg:py-20 overflow-hidden">
      <div className="absolute bottom-0 -left-40 w-[400px] h-[400px] rounded-full bg-[#D4AF37]/5 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <p className="text-sm sm:text-base font-semibold tracking-[0.25em] uppercase text-[#D4AF37] mb-4 text-center">Testimonials</p>
        <h2 className="font-heading heading-fluid font-medium tracking-normal text-metal max-w-3xl mx-auto mb-10 text-center">
          Trusted by Venues. Remembered by Audiences.
        </h2>
        <div className="max-w-4xl mx-auto rounded-3xl p-[2px] bg-gradient-to-br from-[#F3E5AB] via-[#D4AF37] to-[#8a6a10]" data-testid="testimonials-carousel">
          <div className="rounded-3xl bg-[#0A0A0A] px-12 py-8">
            <Carousel opts={{ align: "start", loop: true }} plugins={[Autoplay({ delay: 4500, stopOnInteraction: false, stopOnMouseEnter: true })]}>
            <CarouselContent>
              {testimonials.map((t) => (
                <CarouselItem key={t.author}>
                  <blockquote className="h-full bg-[#121212] border border-white/10 rounded-2xl p-8 lg:p-12 flex flex-col items-center text-center">
                    <div className="flex gap-1 mb-6" aria-label="5 star rating">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} size={22} className="text-[#D4AF37]" fill="#D4AF37" />
                      ))}
                    </div>
                    <p className="text-lg text-zinc-100 leading-relaxed flex-1 max-w-2xl">"{t.quote}"</p>
                    <img
                      src={t.avatar}
                      alt={t.author}
                      className={`w-32 h-32 rounded-full border-2 border-[#D4AF37] mt-6 ${
                        t.isLogo ? "object-contain bg-white p-2" : "object-cover"
                      }`}
                    />
                    <footer className="mt-4 text-sm font-medium text-gold tracking-wide">— {t.author}</footer>
                  </blockquote>
                </CarouselItem>
              ))}
            </CarouselContent>
            {testimonials.length > 1 && (
              <>
                <CarouselPrevious data-testid="testimonials-carousel-prev" className="border-white/20 bg-black/50 text-white hover:bg-[#FF2A2A] hover:text-white" />
                <CarouselNext data-testid="testimonials-carousel-next" className="border-white/20 bg-black/50 text-white hover:bg-[#FF2A2A] hover:text-white" />
              </>
            )}
          </Carousel>
          </div>
        </div>
        <div className="divider-gold mt-14" />
      </div>
    </section>
  );
};

export default Testimonials;
